import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { TestLanguage } from "../hooks/testLanguage";
import { t } from "i18next";

export function Cityauto({
  selectedCity,
  setSelectedCity,
  setRegions,
  onSelect,
}) {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}cities`)
      .then((res) => {
        setCities(res?.data?.data || []);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (event, value) => {
    setSelectedCity(value);
    setRegions(value?.regions || []);
    if (onSelect && value) {
      onSelect("City", value);
    }
  };

  return (
    <Autocomplete
      options={cities}
      getOptionLabel={(option) => TestLanguage(option, "name") || ""}
      value={selectedCity}
      onChange={handleChange}
      loading={loading}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          label={t("drawerUnit.city")}
          InputLabelProps={{
            sx: {
              fontFamily: "Oswald, cairo",
              fontSize:'14px',
              fontWeight: "300"
            },
          }}
          variant="outlined"
          sx={{
            "& fieldset": {
              border: "none",
              boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
            },
            "& .MuiInputLabel-root": {
      color: "black",
    },
          }}
          InputProps={{
            ...params.InputProps,
            style: {
              borderRadius: "35px",
              backgroundColor: "#f5f5f5",
              fontWeight: "bold",
              fontSize: "14px",
              height: "40px",
            },
            endAdornment: loading ? <CircularProgress size={16} /> : "",
          }}
        />
      )}
    />
  );
}
